import React, { memo } from 'react';
export function ProblemSection() {
  const problems = ['You take lots of photos, but very few feel truly special', 'Your dog moves before you get the shot', 'Indoor photos come out dark or flat', 'Outdoor photos feel random or messy', 'You never know which angle looks best', 'You want beautiful memories, but your results feel inconsistent'];
  return <section className="bg-warm-mid py-16 md:py-24 px-4" data-id="element-195">
      <div className="max-w-3xl mx-auto" data-id="element-196">
        {/* Heading */}
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-center text-warm-hero mb-8 leading-tight" data-id="element-197">
          If you're a dog owner, this probably{' '}
          <span className="italic text-soft-gold" data-id="element-198">feels familiar</span>
        </h2>

        {/* Image placeholder */}
        <div className="mb-10 rounded-2xl overflow-hidden shadow-lg max-w-2xl mx-auto" data-id="element-199">
          <img src="https://images.unsplash.com/photo-1544568100-847a948585b9?w=900&h=550&fit=crop&crop=faces" alt="Dog owner scrolling through disappointing phone photos of their dog" className="w-full h-auto object-cover" data-id="element-200" />
        </div>

        {/* Problem list */}
        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-orange/15 mb-8" data-id="element-201">
          <ul className="space-y-5" data-id="element-202">
            {problems.map((item, index) => <li key={index} className="flex items-start" data-id="element-203">
                <span className="text-red-500 mr-4 text-lg mt-0.5 flex-shrink-0" data-id="element-204">
                  ❌
                </span>
                <span className="font-sans text-lg text-gray-700" data-id="element-205">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Closing statement */}
        <div className="text-center max-w-2xl mx-auto" data-id="element-206">
          <p className="font-sans text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-207">
            Your dog is adorable.{' '}
            <span className="font-semibold text-warm-hero" data-id="element-208">
              The problem is not your dog.
            </span>{' '}
            The problem is that you've been relying on random tips instead of{' '}
            <span className="font-semibold text-soft-gold" data-id="element-209">
              a simple system.
            </span>
          </p>
        </div>
      </div>
    </section>;
}